import { authInstance } from './axios';
import { disconnectSocket } from './socketService';
let url = process.env.REACT_APP_API_URL;

// Funcion que consigue el token del session storage

function getToken() {
  try {
    let token = localStorage.getItem('accessToken');
    if (token) {
      return token;
    }
  } catch (error) {
    return null;
  }
}

// Function that gets the user type from the sesion storage
function getUserType() {
  try {
    let user = localStorage.getItem('user');
    user = JSON.parse(user);
    if (user) {
      user = user?.roles[0]?.code;
    }
    return user;
  } catch (error) {
    return null;
  }
}

function getUser() {
  try {
    let user = localStorage.getItem('user');
    user = JSON.parse(user);
    return user;
  } catch (error) {
    return null;
  }
}

function logOut() {
  disconnectSocket();
  localStorage.clear();
  window.location.replace(`login`);
}

function sendOtp(data) {
  return authInstance
    .post(`${url}/otp/sendOtp`, data)
    .then(async (response) => {
      return response;
    })
    .catch(function (error) {
      console.log('error', error);
      error.data = [];
      return error;
    });
}

export default {
  getToken,
  getUserType,
  getUser,
  logOut,
  sendOtp,
};
